import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SlideRightDirective } from '../../../directives/animations/slide-right.directive';

@Component({
  selector: 'section[app-home-welcome]',
  imports: [MatIconModule, SlideRightDirective],
  templateUrl: './home-welcome.html',
  styleUrl: './home-welcome.scss',
})
export class HomeWelcome {}
